import { createSlice } from "@reduxjs/toolkit";
import { epochToDateTime, transformResponse } from "../util/index";
import _ from "lodash";

const reconSipmentsSlice = createSlice({
    name: "reconShipments",
    initialState: {
        reconShipments: []
    },
    reducers: {
        initializeReconShipments: (state, {payload}) => {
            const newPayload = transformResponse(payload);
            state.reconShipments = newPayload;
        },
        addReconShipment: (state, {payload}) => {
            let newShipment = transformResponse([payload]);
            state.reconShipments = [...newShipment, ...state.reconShipments]
        }
    }
})

export const { initializeReconShipments, addReconShipment } = reconSipmentsSlice.actions

export default reconSipmentsSlice.reducer